
import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";



import Home from './pages/Home'
import About from './pages/About'
import ContactUs from "./pages/ContactUs"
import MechanicalWorks from "./pages/services/MechanicalWorks";
import MetalFabrication from "./pages/services/MetalFabrication";
import CivilWorks from "./pages/services/CivilWorks";
import EnvironmentalSafety from './pages/services/EnviromentalSolutions'
import Procurement from './pages/services/Procurement'
import Careers from './pages/Careers'
import NotFound from './pages/NotFound'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Who-We-Are" element={<About />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/Careers" element={<Careers />} />
        <Route path="/Mechanical-Works" element={<MechanicalWorks />} />
        <Route path="/Metal-Fabrication" element={<MetalFabrication />} />
        <Route path="/Civil-Works" element={<CivilWorks />} />
        <Route path="/HSE-Solutions-and-Consultancy" element={<EnvironmentalSafety />} />
        <Route path="/General-Procurement" element={<Procurement />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
